<template>
	<el-dialog :visible.sync="visible"
		:title="$t('slb.text.addCert')"
		:close-on-click-modal="false"
		:before-close="handleClose" class="bind-dialog  create-host">
		<el-form label-width="120px" :model="ruleForm" ref="ruleForm"
                :rules="rules" class="all-input">
			<!-- 地域 -->
			<el-form-item :label="$t('create.text.region') | withColon">
				<el-radio-group 
					v-model="ruleForm.selectedRegion">
					<el-radio-button v-for="(regionName,region,index) in regions" :key="index"
						:label="region">
						{{regionName}}
					</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<!-- 名称 -->
			<el-form-item 
                :label="$t('slb.text.name') | withColon" prop="name" :show-message="false"
                ref="name" required>
                <el-input v-model="ruleForm.name"
                    @blur="ruleFormTag.name=1"
                    @focus="ruleFormTag.name=0"></el-input>
                <p  v-if="ruleFormTag.name!==0 && ruleForm.name==''" class="el-form-item-help-error">
                    {{$t('create.placeholder.nameNull')}}</p>
                <p  v-else class="el-form-item-name-help"
                    :class="{'el-form-item-help-error': this.ruleFormTag.name == 'error'}">
                    {{$t('create.help.name')}}</p>
            </el-form-item>
			<!-- 证书内容 -->
			<el-form-item 
				:label="$t('slb.text.certContent') | withColon" prop="certificate"
				:show-message="false" required>
				<el-input type="textarea" :rows="4" v-model="ruleForm.certificate" class="colorChange"
					placeholder=""
					@blur="ruleFormTag.certificate=1"
                    @focus="ruleFormTag.certificate=0"></el-input>
				<p  v-if="ruleFormTag.certificate!==0 && ruleForm.certificate==''" class="el-form-item-help-error">
                    {{$t('slb.tooltip.certNull')}}</p>
				<div class="right"><el-button type="text" @click="exampleCert">{{$t('slb.text.example')}}</el-button></div>
			</el-form-item>
			<!-- 私钥 -->
			<el-form-item 
				:label="$t('slb.text.subKey') | withColon" prop="privateKey" class="colorChange"
				:show-message="false" required>
				<el-input type="textarea" :rows="4" v-model="ruleForm.privateKey"
					placeholder=""
					@blur="ruleFormTag.privateKey=1"
                    @focus="ruleFormTag.privateKey=0"></el-input>
					<p  v-if="ruleFormTag.privateKey!==0 && ruleForm.privateKey==''" class="el-form-item-help-error">
                    {{$t('slb.tooltip.privateKeyNull')}}</p>
				<div class="right"><el-button type="text" @click="exampleKey">{{$t('slb.text.example')}}</el-button></div>
			</el-form-item>			
		</el-form>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind"
				type="primary">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { NetworkTypeConstant } from '@/common/Constants';
export default {
	name: 'createCert',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		
		region: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			regions: {},
			ruleForm: {
                name: '',
				certificate:'',
				privateKey:'',
				selectedRegion: this.region,
            },
			rules: {
                name: [
                    {
                        type: 'string',
                        pattern: new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$'),
                        trigger: 'blur'
                    }
                ],
            },
			ruleFormTag: {
                name: 0,
				certificate:0,
				privateKey:0,
            },
		};
	},
	computed:{
		 currentSelectedRegion() {
            return this.ruleForm.selectedRegion;
        },
	},
	created() {
        this.getRegions();
    },
	methods: {
		//关闭弹框
		handleClose() {
			this.doReset('ruleForm');
			this.$emit('update:visible', false);	
		},
		//清空表单
		doReset(formName) {
			console.log(this.$refs)
            this.$refs[formName].resetFields();
            this.ruleFormTag.name = 0;
			this.ruleFormTag.certificate = 0;
			this.ruleFormTag.privateKey = 0;
        },
		getRegions() {
          Ajax.get({
            action: '/cpslbRegions',
			param: {
						networkType: NetworkTypeConstant.VPC
					},
            success: (data) => {
              for (const i in data.regions) {
                const region = data.regions[i].region;
                const regionName = data.regions[i].regionName;
                this.regions[region] = regionName;
              }
            const passedRegion = this.region;
			if (passedRegion != undefined) {
                this.ruleForm.selectedRegion = passedRegion;
              } else {
                this.ruleForm.selectedRegion = data.regions[0].region;
              }
             
            }
          });
        },
		//点击取消按钮
		cancelBind() {
			this.handleClose();
		},
		//点击展示证书内容样例
		exampleCert() {
			this.ruleForm.certificate = "-----BEGIN CERTIFICATE-----\nMIIDkjCCAnoCCQCnaPVZ1ELSDTANBgkqhkiG9w0BAQUFADCBijELMAkGA1UEBhMC\nQ04xEDAOBgNVBAgMB0JlaWppbmcxEDAOBg...\n-----END CERTIFICATE-----"
		},
		//点击展示私钥样例
		exampleKey() {
			this.ruleForm.privateKey = "-----BEGIN RSA PRIVATE KEY-----\nMIIEowIBAAKCAQEA20JWN9yeVpR5qWBcpwR2Lj6z6hfEW7lMIZw4IJIm51cgpQCo\nYQk+Y9TEktDh7Ovdfot4sa0hlJq/YxLDf...\n-----END RSA PRIVATE KEY-----"
		},
		//点击确认按钮
		sureBind() {
			this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.createCert();
                }
            });
		},
		createCert() {
			const param = {
				region: this.ruleForm.selectedRegion,
				name: this.ruleForm.name,
				certificate: this.ruleForm.certificate,
				privateKey: this.ruleForm.privateKey,
				clientToken: Normal.getClientToken(),
			};
			Ajax.put('/api/cps/addCertificate', param)
            .then(() => {
                this.$emit('refresh');
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
            });
		},

	},
};
</script>

<style lang="scss" scoped>
.right {
	text-align: right;
}

.colorChange {
	.el-textarea__inner {
		color: #9e9e9e;	
	}
}

.all-input {
	width: 90% !important;
}

</style>


// WEBPACK FOOTER //
// src/components/slb/createCert.vue